import React from 'react';
import { useTranslation } from 'react-i18next';

import './PaymentModal.scss';

function ErrorPayment() {
  const { t } = useTranslation();
  return (
    <div className="payment-modal">
      <div className="payment-modal__title">{ t('depositFunds.error') }</div>
      <div className="payment-modal__text">{ t('depositFunds.errorMessage') } </div>
    </div>
  );
}

export default ErrorPayment;
